export interface PlayerStats {
    scoredGoals: number;
    thrown7m: number;
    scored7m: number;
    warning: string;
    disqualify: string;
    timeouts: string[];
}

export default class StatisticManager {
    
    private static stats: PlayerStats[][];
    
    public static reset() {
//        console.log("StatisticManager#reset");
        this.stats=[];
        this.stats[0]=[];
        this.stats[1]=[];
    }
    
    private static indexFromPlayerNo(playerno: string):number {
        var index=parseInt(playerno);
        if (isNaN(index)) {
            var charPos = 0;
            while (charPos < playerno.length-1 && playerno.charCodeAt(charPos) == 32) {
                charPos++;
            }
            index=playerno.charCodeAt(charPos)+100;
        }
        // console.log("convert player no "+playerno+" to index "+index);
        return index;
    }
    
    public static getStats(team: number, playerno: string) : PlayerStats {
        if (this.stats[team-1] === undefined) {
            this.stats[team-1] = [];
        }
        var index:number=this.indexFromPlayerNo(playerno);
        if (this.stats[team-1][index] === undefined) {
            this.stats[team-1][index] = {
                scoredGoals: 0,
                thrown7m: 0,
                scored7m: 0,
                warning: "",
                disqualify: "",
                timeouts: [],
            };
        }
        return this.stats[team-1][index];
    }
    
    public static addGoal(team: number, playerno: string) {
        this.getStats(team, playerno).scoredGoals++;
    }
    
    public static addMissed7m(team: number, playerno: string) {
        this.getStats(team, playerno).thrown7m++;
    }

    public static addScored7m(team: number, playerno: string) {
        var stats=this.getStats(team, playerno);
        stats.thrown7m++;
        stats.scored7m++;
        stats.scoredGoals++;
    }
    
    public static addWarning(team: number, playerno: string, time: string) {
        this.getStats(team, playerno).warning=time;
    }
    
    public static addDisqualify(team: number, playerno: string, time: string) {
        this.getStats(team, playerno).disqualify=time;
    }
    
    public static addTimeout(team: number, playerno: string, time: string) {
        this.getStats(team, playerno).timeouts.push(time);
    }

    public static getGoals(team: number, playerno: string):string {
        return ""+this.getStats(team, playerno).scoredGoals;
    }
    
    public static get7m(team: number, playerno: string):string {
        return this.getStats(team, playerno).thrown7m + "/" + this.getStats(team, playerno).scored7m;
    }
    
    public static getWarning(team: number, playerno: string):string {
        return this.getStats(team, playerno).thrown7m + "/" + this.getStats(team, playerno).warning;
    }
    
    public static getDisqualify(team: number, playerno: string):string {
        return this.getStats(team, playerno).thrown7m + "/" + this.getStats(team, playerno).disqualify;
    }
    
    public static getTimeout(team: number, playerno: string, index: number):string {
        return this.getStats(team, playerno).thrown7m + "/" + this.getStats(team, playerno).timeouts[index];
    }
}


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/StatisticManager.ts